import hyperdom from 'hyperdom'

class Message {
  constructor ({className, header, hideIcon, message, onClose, type}) {
    this.className = className
    this.header = header
    this.message = message
    this.type = type
    this.hideIcon = hideIcon
    this.onClose = onClose
  }

  render () {
    return <div className={[this.className, `message-${this.type}`].filter(Boolean)}>
      { !this.hideIcon ? <div class="message__icon"></div> : undefined }
      <div class="message__content">
        { this.header ? <span class="message__header">{ this.header }</span> : undefined }
        { this.message ? <span class="message__text">{ this.message }</span> : undefined }
      </div>
      { this.onClose ? <i className="message__close" onclick={() => this.onClose()}></i> : undefined }
    </div>
  }
}

const MessageTypes = {
  WARNING: 'warning',
  INFO: 'info',
  SUCCESS: 'success',
  ERROR: 'error',
}

export {Message, MessageTypes}
